<template>
  <div class="dialog-container wt-dialog-container">
    <div>
      <wt-readonly-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm" :readonly="true" >
        <template slot="operate">
          <span style="margin-left: 13px;color: #333333;" v-if="detailFormData.operate*1 === 0">待处理</span>
          <span style="margin-left: 13px;color: #333333;" v-if="detailFormData.operate*1 === 1">已处理返回</span>
          <span style="margin-left: 13px;color: #333333;" v-if="detailFormData.operate*1 === 2">不予理会</span>
        </template>
      </wt-readonly-form-section>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'orderAbnormalView',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      formCode: 'MODULES_USERDELIVERYGARBAGE',
      isSubmitLoading: false,
      formUpdateUrl: '/modules/userDeliveryGarbage/userDeliveryGarbageUpdate',
      formAddUrl: '/modules/userDeliveryGarbage/userDeliveryGarbageAdd',
      detailFormButtons: {
        title: '详情',
        elements: [{ name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailForm: {
        title: '详情',
        className: 'wt-section-long-content',
        elements: [
          { name: '昵称', key: 'nickName', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '手机号', key: 'phone', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '社区', key: 'communityName', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '订单编号', key: 'orderNumber', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '下单时间', key: 'createTime', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '兑换积分', key: 'totalIntegral', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '处理结果', key: 'operate', type: 'custom', disabled: true, className: 'wt-col-12' },
          { name: '图片', key: 'coverList', type: 'image', disabled: true, className: 'wt-col-12' }]
      }
    }
  },
  created() {
    this.$store.dispatch('appendBreadcrumb', { meta: { title: '详情' }})
    if (this.detailFormData && this.detailFormData.pictures) {
      if (this.detailFormData.pictures && this.detailFormData.pictures.length > 0) {
        const _coverList = this.detailFormData.pictures.split(',')
        this.detailFormData.coverList = []
        for (const item of _coverList) {
          this.detailFormData.coverList.push({ fileUrl: item })
        }
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
        this.$store.dispatch('removeBreadcrumb')
      }
    },
    /*  ------------------------- 网络请求  -------------------------  */
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    }
  },
  computed: {
    ...mapState({
      detailFormData: state => state.orderAbnormal.orderAbnormalDetailData
    })
  }
}
</script>

<style scoped>
.detail-img {
  width: 80px;
  height: 80px;
  margin-right: 20px;
}
</style>
